import React, { useState } from "react";
import {
  Box,
  FormControlLabel,
  makeStyles,
  Paper,
  Radio,
  Typography,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";
import Text from "../../../../../shared/components/Text";
import { LoanApplicationStatusTag } from "./LoanApplicationStatusTag";
import { Skeleton } from "@material-ui/lab";

export const LenderSelectionItem = ({ loanApplication }) => {
  const { breakpoints } = useTheme();
  const isScreenXs = useMediaQuery(breakpoints.down("xs"));

  const useStyles = makeStyles({
    root: {
      marginLeft: 0,
      width: "100%",
    },
    label: {
      width: "100%",
    },
  });

  const classes = useStyles();

  return (
    <Paper elevation={2} style={{ paddingInline: "8px 16px" }}>
      <FormControlLabel
        classes={{ root: classes.root, label: classes.label }}
        value={loanApplication.id}
        control={<Radio />}
        label={
          <Box
            display={"flex"}
            minWidth={"100%"}
            style={{ padding: "12px 0px" }}
          >
            <Box
              display={"flex"}
              flexDirection={"row"}
              width={"100%"}
              justifyContent={"space-between"}
              alignItems={"center"}
              gridGap={4}
              px={isScreenXs ? 0 : 1}
            >
              <LenderIcon lenderName={loanApplication.lender_name} />
              <Box display={"flex"} flexDirection={"row"} gridGap={16}>
                <CalculatorSpec
                  label={"INSTALMENT_AMOUNT"}
                  value={loanApplication.loanCalculator.instalmentAmount.string}
                />
                <CalculatorSpec
                  label={"TAE"}
                  value={loanApplication.loanCalculator.apr.string}
                />
                <CalculatorSpec
                  label={"TO_PAY"}
                  value={loanApplication.loanCalculator.totalAmount.string}
                />
              </Box>
              <Box
                display={"flex"}
                flexDirection={"row"}
                gridGap={4}
                alignItems={"center"}
                justifyContent={"flex-end"}
              >
                <LoanApplicationStatusTag loanApplication={loanApplication} />
              </Box>
            </Box>
          </Box>
        }
      />
    </Paper>
  );
};

export const CalculatorSpec = ({ value, label }) => {
  return (
    <Box
      display={"flex"}
      flexDirection={"column"}
      gridGap={0}
      justifyContent={"flex-start"}
    >
      <Typography variant="caption" color="textSecondary">
        <Text tId={label} />
      </Typography>
      <Typography variant="subtitle2" color="title">
        {value}
      </Typography>
    </Box>
  );
};

export const LenderIcon = ({
  lenderName,
  size = 22,
  isActive = true,
  altColor = false,
  ...props
}) => {
  const [isLoaded, setIsLoaded] = useState(false);

  const isIdleStyles = {
    filter: altColor ? "brightness(0) invert(1)" : "grayscale(1) contrast(0)",
    opacity: altColor ? 0.5 : 0.4,
  };

  return (
    <>
      {!isLoaded && <Skeleton variant="rect" width={size} height={size} />}
      <img
        src={`https://cdn.nemuru.com/assets/logos/letterform/${lenderName}-logo.svg`}
        alt={lenderName}
        onLoad={() => {
          setIsLoaded(true);
        }}
        {...props}
        style={{
          ...props.style,
          display: isLoaded ? "block" : "none",
          width: `${size}px`,
          height: "auto",
          ...(isActive ? {} : isIdleStyles),
        }}
      />
    </>
  );
};
